'use client';
import * as React from 'react';
const BreadcrumbContext = React.createContext(undefined);
/**
 * @internal
 */ export const breadcrumbDefaultValue = {
    size: 'medium'
};
/**
 * @internal
 */ export const BreadcrumbProvider = BreadcrumbContext.Provider;
/**
 * @internal
 */ export const useBreadcrumbContext_unstable = ()=>{
    var _React_useContext;
    return (_React_useContext = React.useContext(BreadcrumbContext)) !== null && _React_useContext !== void 0 ? _React_useContext : breadcrumbDefaultValue;
};
